import apiClient from './api';
import { API_CONFIG } from '../utils/constants';
import { Parametros } from '../models/Parametros';

export class ParametroService {
  
  // Obtener todos los roles
  static async getAllPa(id) {
    try {
      // console.log('🔍 === GETALLROLES DEBUG ===');
      // console.log('🔍 URL:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.ROLES);
      
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.PARAMETROS}/sucursal/${id}`);
      
      // console.log('✅ Respuesta cruda del API:', response.data);
      // console.log('✅ Tipo de response.data:', typeof response.data);
      // console.log('✅ Keys de response.data:', Object.keys(response.data));
      
      // ✅ MANEJO ESPECÍFICO PARA TU FORMATO DE API
      let Data;
      if (response.data.success && response.data.data) {
        Data = response.data.data; // Tu formato: {success: true, data: [...]}
        //console.log('✅ Usando response.data.data (formato success/data)');
      } else if (Array.isArray(response.data)) {
        Data = response.data; // Formato directo: [...]
        //console.log('✅ Usando response.data (formato array directo)');
      } else {
        //console.error('❌ Formato de API no reconocido:', response.data);
        throw new Error('Formato de datos incorrecto del servidor');
      }
      
      // console.log('✅ Datos extraídos:', rolesData);
      // console.log('✅ Es array?', Array.isArray(rolesData));
      // console.log('✅ Cantidad de elementos:', rolesData.length);
      
      if (!Array.isArray(Data)) {
        //console.error('❌ rolesData no es array:', rolesData);
        throw new Error('Los datos recibidos no son un array');
      }
      
      // ✅ MAPEAR CADA ROL Y MOSTRAR DEBUG
      const mapped = Data.map((rData, index) => {
        //console.log(`🔍 Mapeando rol ${index}:`, roleData);
        const data = new Parametros(rData);
        //console.log(`✅ Rol mapeado ${index}:`, data.toDebug());
        return data;
      });
      
      //console.log('✅ TODOS LOS ROLES MAPEADOS:', mapped);
      return mapped;
      
    } catch (error) {
      console.error('❌ === ERROR GETALLROLES ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response:', error.response);
      console.error('❌ Error message:', error.message);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Status Text:', error.response.statusText);
        console.error('❌ Data:', error.response.data);
        console.error('❌ Headers:', error.response.headers);
      }
      
      throw new Error('Error al obtener Parametros: ' + error.message);
    }
  }

  // Obtener rol por ID
  static async getById(id) {
    try {
      //console.log('🔍 Obteniendo rol ID:', id);
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.PARAMETROS}/sucursal/${id}`);
      console.log('✅ Parametros obtenido:', response.data);
      
      const rData = response.data.data || response.data;
      return new Parametros(rData);
    } catch (error) {
      console.error('❌ Error obteniendo Parametros:', error);
      throw new Error('Error al obtener el Parametros');
    }
  }

  // Crear nuevo rol
  static async create(Data) {
    try {
      const data = new Parametros(Data);
      //const apiData = data.toApiFormat()
      console.log('🔍 Creando Parametros:', data.toCreateFormat());
      
      const response = await apiClient.post(API_CONFIG.ENDPOINTS.PARAMETROS, data.toCreateFormat());
      console.log('✅ Parametros creado:', response.data);
      
      const createdData = response.data.data || response.data;
      return new Parametros(createdData);
    } catch (error) {
      console.error('❌ Error creando Parametros:', error);
      throw new Error('Error al crear el Parametros');
    }
  }

  // Actualizar rol
  static async update(id, Data) {
    try {
      console.log('🔍 === UPDATE DEBUG ===');
      console.log('🔍 ID:', id);
      console.log('🔍 Data:', Data);
      
      if (!id) {
        throw new Error('ID de Parametros no proporcionado');
      }
      
      let data;
      if (Data instanceof Parametros) {
        data = Data;
      } else {
        data = new Parametros(Data);
      }
      
      const dataToSend = data.toApiFormat();
      console.log('********* 🔍 Data convertido a formato API (minúsculas):', dataToSend);
      
      const response = await apiClient.put(`${API_CONFIG.ENDPOINTS.PARAMETROS}/${id}`, dataToSend);
      //console.log('✅ Role actualizado:', response.data);
      
      const updatedData = response.data.data || response.data;
      return new Parametros(updatedData);
      
    } catch (error) {
      console.error('❌ Error actualizando Parametros:', error);
      throw new Error('Error al actualizar el Parametros');
    }
  }

  static async deleteRole(id) {
    try {
      console.log('🔍 Eliminando Parametros ID:', id);
      await apiClient.delete(`${API_CONFIG.ENDPOINTS.PARAMETROS}/${id}`);
      console.log('✅ Parametros eliminado exitosamente');
      return true;
    } catch (error) {
      console.error('❌ Error eliminando Parametros:', error);
      throw new Error('Error al eliminar el Parametros');
    }
  }

  // MÉTODO DE PRUEBA
  static async testConnection() {
    try {
      console.log('🧪 === TEST CONNECTION ===');
      console.log('🧪 URL Base:', API_CONFIG.BASE_URL);
      console.log('🧪 Endpoint:', API_CONFIG.ENDPOINTS.PARAMETROS);
      console.log('🧪 URL Completa:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.PARAMETROS);
      
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.PARAMETROS);
      console.log('✅ ¡CONEXIÓN EXITOSA!');
      console.log('✅ Response completo:', response);
      console.log('✅ Response data:', response.data);
      
      return response;
    } catch (error) {
      console.error('❌ FALLO EN LA CONEXIÓN:', error);
      console.error('❌ Error response:', error.response);
      return error;
    }
  }
}